"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var tokenized_credit_card_fields_1 = require("./tokenized_credit_card_fields");
var TokenizedCreditCardHiddenFields = function (props) { return (React.createElement("div", null,
    React.createElement(tokenized_credit_card_fields_1.default, { onTokenizedFieldUpdate: props.onTokenizedFieldUpdate, onCardDataUpdate: props.onCardDataUpdate }),
    React.createElement("input", { type: "hidden", name: "credit_card[tokenized_data][encryptedCardNumber]", value: props.tokenizedFields.encryptedCardNumber }),
    React.createElement("input", { type: "hidden", name: "credit_card[tokenized_data][encryptedExpiryMonth]", value: props.tokenizedFields.encryptedExpiryMonth }),
    React.createElement("input", { type: "hidden", name: "credit_card[tokenized_data][encryptedExpiryYear]", value: props.tokenizedFields.encryptedExpiryYear }),
    React.createElement("input", { type: "hidden", name: "credit_card[tokenized_data][encryptedSecurityCode]", value: props.tokenizedFields.encryptedSecurityCode }),
    React.createElement("input", { type: "hidden", name: "credit_card[type]", value: props.cardData.cardType }),
    React.createElement("input", { type: "hidden", name: "credit_card[last_4]", value: props.cardData.last4 }))); };
exports.default = TokenizedCreditCardHiddenFields;
//# sourceMappingURL=tokenized_credit_card_hidden_fields.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/tokenized_credit_card_hidden_fields.js
// module id = E5LF
// module chunks = 20 21 22